import { Link } from "@remix-run/react";
import { Card } from "~/components/ui/card";
import { getRegionUrlPrefix } from "~/lib/helpers/slugHelper";

interface TipAndGuide {
  id: string;
  image: string;
  title: string;
  slug?: string;
}

interface TipsCardProps {
  tipAndGuide: TipAndGuide;
  region: string;
  className?: string;
}

export default function TipsCard({ tipAndGuide, region, className }: TipsCardProps) {
  // Generate ImageKit optimized URL
  const imageUrl = tipAndGuide?.image
    ? `https://ik.imagekit.io/officehub/tr:h-1060,f-auto,f-avif/${tipAndGuide.image}`
    : "/placeholder.svg";

  const linkTo = `${getRegionUrlPrefix(region)}/blog/${tipAndGuide?.slug}`;

  return (
    <Card className={`relative w-full overflow-hidden group rounded-lg shadow-md ${className}`}>
      {/* Image background Link */}
      <Link to={linkTo} target="_blank" className="absolute inset-0 block w-full h-full z-0">
        <img
          src={imageUrl}
          alt={tipAndGuide?.bannerImageAltText || tipAndGuide?.id || "Tips and guides"}
          width={400}
          height={530}
          className="object-cover w-full h-full"
          loading="lazy"
        />
      </Link>

      {/* Overlay + Content */}
      <div className="relative flex flex-col justify-end h-full pointer-events-none z-10">
        {/* Gradient overlay */}
        <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-black to-transparent"></div>
        {/* Card Text */}
        <div className="relative z-10 p-4 pointer-events-auto">
          <Link to={linkTo} target="_blank">
            <h3 className="text-base text-white leading-tight line-clamp-3">
              {tipAndGuide?.title}
            </h3>
          </Link>
        </div>
      </div>
    </Card>
  );
}